@if (!isDisabled && items()) {
  <div>
    <div class="search-bar">
      <wr-search-bar class="grow"
                     [search]="searchText()"
                     (searchChange)="searchTextChange($event)">
      </wr-search-bar>
      @if (selectionSummary(); as summary) {
        <div class="selection-info" [class.has-not-visible]="summary.notVisible > 0">
          <span data-cy="pick-list-selection">{{ summary.label }}</span>
          <button type="button"
                  nbButton
                  ghost
                  size="tiny"
                  data-cy="pick-list-clear-selection"
                  nbTooltip="Auswahl aufheben"
                  aria-label="Auswahl aufheben"
                  (click)="clearSelection()">
            <nb-icon icon="close-outline" pack="eva"></nb-icon>
          </button>
        </div>
      }
      @if (showToggleAlreadyAssignedToOthers() && !alwaysShowAssignedToOthers()) {
        <button type="button"
                nbSuffix
                nbButton
                (click)="toggleAssignedItems()"
                [nbTooltip]="assignedItemsToggleTooltip()">
          <nb-icon [icon]="assignedItemsToggleIcon()" pack="eva"></nb-icon>
        </button>
      }
    </div>

    @if (unassignedItems().length || valueSignal()?.length) {
      <div class="lists">

        <!-- UNASSIGNED ITEMS LIST -->
        <div class="unassigned-list" (scroll)="onUnassignedScroll($event)">
          <div class="unassigned-list-header">Nicht zugewiesen</div>

          @if (filteredUnassignedItems().length) {
            <div>
              @for (item of filteredUnassignedItems(); track item.id) {
                <div class="list-item"
                     [class.selected]="isSelected(item)">
                  <nb-checkbox
                    [checked]="isSelected(item)"
                    (checkedChange)="onSelectionChange($event, item)"
                    [disabled]="isAssignedElsewhere(item) && !alwaysShowAssignedToOthers()">
                    <div class="checkbox-content">
                      <div class="item-name">
                        {{ displayName(item) }}
                      </div>
                      <div class="item-info">
                        @if (firstAdditionalInfo(item).length > 0) {
                          <div class="first-info">
                            <nb-icon icon="hash-outline" pack="eva"></nb-icon>
                            {{ firstAdditionalInfo(item) }}
                          </div>
                        }
                        @if (secondAdditionalInfo(item).length > 0) {
                          <div class="second-info">
                            <nb-icon icon="crop-outline" pack="eva"></nb-icon>
                            {{ secondAdditionalInfo(item) }}
                          </div>
                        }
                        @if (thirdAdditionalInfo(item).length > 0) {
                          <div class="third-info">
                            <nb-icon icon="people-outline" pack="eva"></nb-icon>
                            {{ thirdAdditionalInfo(item) }}
                          </div>
                        }
                      </div>
                    </div>
                  </nb-checkbox>
                  @if (isAssignedElsewhere(item) && !alwaysShowAssignedToOthers()) {
                    <button type="button"
                            nbSuffix
                            nbButton
                            (click)="moveAlreadyAssignedToThis($event, item)"
                            nbTooltip="Zuweisen">
                      <nb-icon icon="log-in-outline" pack="eva"></nb-icon>
                    </button>
                  }
                </div>
              }
            </div>
          } @else {
            <span class="text-hint-no-items">
              <nb-icon icon="slash-outline" pack="eva"></nb-icon>
              <span>Es existieren keine nicht zugewiesenen Elemente</span>
            </span>
          }
        </div>

        <!-- ACTION BUTTONS -->
        <div class="switch-buttons">
          <button type="button"
                  nbButton ghost
                  class="switch-button-right"
                  nbTooltip="Ausgewählte zuweisen"
                  (click)="moveSelectedToAssigned()">
            <nb-icon icon="arrow-forward-outline" pack="eva"></nb-icon>
          </button>

          <button type="button"
                  nbButton ghost
                  class="switch-button-left"
                  nbTooltip="Ausgewählte entfernen"
                  (click)="moveSelectedToUnassigned()">
            <nb-icon icon="arrow-back-outline" pack="eva"></nb-icon>
          </button>
        </div>

        <!-- ASSIGNED ITEMS LIST -->
        <div class="assigned-list">
          <div class="assigned-list-header">Zugewiesen</div>

          @if (filteredAssignedItems()?.length) {
            <div>
              @for (item of filteredAssignedItems() ?? []; track item.id) {
                <div class="list-item"
                     [class.selected]="isSelected(item)">
                  <nb-checkbox
                    [checked]="isSelected(item)"
                    (checkedChange)="onSelectionChange($event, item)">
                    <div class="checkbox-content">
                      <div class="item-name">
                        {{ displayName(item) }}
                      </div>
                      <div class="item-info">
                        @if (firstAdditionalInfo(item).length > 0) {
                          <div class="first-info">
                            <nb-icon icon="hash-outline" pack="eva"></nb-icon>
                            {{ firstAdditionalInfo(item) }}
                          </div>
                        }
                        @if (secondAdditionalInfo(item).length > 0) {
                          <div class="second-info">
                            <nb-icon icon="crop-outline" pack="eva"></nb-icon>
                            {{ secondAdditionalInfo(item) }}
                          </div>
                        }
                        @if (thirdAdditionalInfo(item).length > 0) {
                          <div class="third-info">
                            <nb-icon icon="people-outline" pack="eva"></nb-icon>
                            {{ thirdAdditionalInfo(item) }}
                          </div>
                        }
                      </div>
                    </div>
                  </nb-checkbox>
                </div>
              }
            </div>
          } @else {
            <span class="text-hint-no-items">
              <nb-icon icon="slash-outline" pack="eva"></nb-icon>
              <span>Es existieren keine zugewiesenen Elemente</span>
            </span>
          }
        </div>

      </div>
    }
  </div>
}

<!-- DISABLED / READ-ONLY VIEW -->
@if (isDisabled && filteredAssignedItems()?.length) {
  <div class="disabled-assigned-list">
    <div class="disabled-assigned-list-header">Zugewiesen</div>

    @for (item of filteredAssignedItems() ?? []; track item.id) {
      <div class="disabled-list-item">
        <div class="checkbox-content">
          <div class="item-name">
            {{ displayName(item) }}
          </div>
          <div class="item-info">
            @if (firstAdditionalInfo(item).length > 0) {
              <div class="first-info">
                <nb-icon icon="hash-outline" pack="eva"></nb-icon>
                {{ firstAdditionalInfo(item) }}
              </div>
            }
            @if (secondAdditionalInfo(item).length > 0) {
              <div class="second-info">
                <nb-icon icon="crop-outline" pack="eva"></nb-icon>
                {{ secondAdditionalInfo(item) }}
              </div>
            }
            @if (thirdAdditionalInfo(item).length > 0) {
              <div class="third-info">
                <nb-icon icon="people-outline" pack="eva"></nb-icon>
                {{ thirdAdditionalInfo(item) }}
              </div>
            }
          </div>
        </div>
      </div>
    }
  </div>
} @else if (isDisabled) {
  <span class="text-hint-no-items">
    <nb-icon icon="slash-outline" pack="eva"></nb-icon>
    <span>Es existieren keine zugewiesenen Elemente</span>
  </span>
}
